<template>
  <div class="games-page">
    <el-backtop></el-backtop>
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Games",
});
</script>

<style lang="scss" scoped>
.games-page {
  height: calc(100% - 60px);
  margin: 0 auto;
  padding: size("XL") size("L");

  @include wide-screen {
    width: calc(100% - 60px);
    max-width: 2000px;
  }
}
</style>
